import React from 'react';
import PropTypes from 'prop-types';
import Dashboard from '../src/index';
import LandingPage from '../src/components/LandingPage';
import pkg from '../package.json';
import { namespace } from './configs/projectNames';

/**
 * @function Root Main function
 * @param props
 * @returns
 */
export default function Root(props) {
  //  Root(props) {
  // You can find all Shell´s props here. See "./types/shell" for more details.
  // const { v1 } = window.Shell as ShellProps

  // You can find the "stack" information by props
  // const stack = props.stack.

  const shell = window.Shell.v1;
  const { properties } = props;
  const { landingPage = false } = properties;
  const dashboard = !landingPage;

  return (
    <section
      id={pkg.name}
      className={namespace}
      style={{
        height: '100%',
        minHeight: 'calc(100vh - 176px)',
      }}
    >
      {landingPage && <LandingPage {...props} shell={shell} />}
      {dashboard && <Dashboard {...props} shell={shell} />}
    </section>
  );
}

Root.propTypes = {
  properties: PropTypes.shape({
    landingPage: PropTypes.bool,
  }),
};

Root.defaultProps = {
  properties: {
    landingPage: false,
  },
};
